/*
 * Rennsieger — Carbon "Form and Function" dossier.
 * Ported from the mockup script: the glassmorphic "Dossier" definition popup
 * (hover/focus via CSS, click to pin, outside-click closes), the FAQ accordions,
 * the reveal animation, and the two-option context-aware sticky built from the
 * teaser's ?type=&coll= params.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-rsg-cds]');
  if (!root) return;

  var iBack = '<path d="M15 18l-6-6 6-6"/>';
  var iGrid = '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>';

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function sfn(cls, label, icon, href) {
    return '<a class="sfn ' + cls + '" href="' + esc(href) + '"><svg viewBox="0 0 24 24" aria-hidden="true">' + icon + '</svg><span class="lbl">' + esc(label) + '</span></a>';
  }

  function buildSticky() {
    var host = document.querySelector('[data-rsg-cds-sticky-in]');
    if (!host) return;
    var params = new URLSearchParams(location.search);
    var allUrl = root.getAttribute('data-all-url') || '/collections/carbon';
    var type = params.get('type');
    var coll = params.get('coll');
    if (type && coll) {
      host.innerHTML = sfn('primary', 'Back to ' + type, iBack, coll) + sfn('', 'All Carbon', iGrid, allUrl);
    } else {
      host.innerHTML = sfn('primary', 'Shop Carbon', iGrid, allUrl);
    }
  }

  function initDossier() {
    root.querySelectorAll('.dossier .dw').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var d = btn.closest('.dossier');
        var open = d.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function () {
      root.querySelectorAll('.dossier.open').forEach(function (d) {
        d.classList.remove('open');
        var b = d.querySelector('.dw');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initAcc() {
    root.querySelectorAll('.acc-head').forEach(function (h) {
      h.addEventListener('click', function () { h.parentElement.classList.toggle('open'); });
    });
  }

  function initReveal() {
    var els = Array.prototype.slice.call(root.querySelectorAll('.reveal'));
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var obs = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); } });
      }, { threshold: 0.06 });
      els.forEach(function (el) { obs.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('in'); });
    }
  }

  function boot() { buildSticky(); initDossier(); initAcc(); initReveal(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }
})();
